import React from 'react';
import { Percent, Lock, Megaphone, Heart } from 'lucide-react';
import { mockData } from '../mock/mockData';

const Tokenomics = () => {
  const { tokenomics } = mockData;

  const iconMap = {
    0: <Percent size={40} />,
    1: <Lock size={40} />,
    2: <Megaphone size={40} />,
    3: <Heart size={40} />
  };

  return (
    <section id="tokenomics" className="tokenomics-section">
      <div className="section-container">
        <h2 className="section-title">{tokenomics.title}</h2>
        
        <div className="tokenomics-grid">
          {tokenomics.items.map((item, index) => (
            <div key={index} className="tokenomics-card">
              <div className="tokenomics-icon">
                {iconMap[index]}
              </div>
              <div className="tokenomics-percentage">{item.percentage}</div>
              <h3 className="tokenomics-title">{item.title}</h3>
              <p className="tokenomics-description">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="tokenomics-highlight">
          <img 
            src="https://images.pexels.com/photos/6770521/pexels-photo-6770521.jpeg"
            alt="Tokenomics Background"
            className="tokenomics-bg-image"
          />
        </div>
      </div>
    </section>
  );
};

export default Tokenomics;
